import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-session-expired',
  templateUrl: './session-expired.component.html',
  styleUrls: ['./session-expired.component.scss'],
})
export class SessionExpiredComponent {
  snoozeMinutes = 15;
  snoozeOptions: { label: string; value: number }[];

  constructor(
    public activeModal: NgbActiveModal,
    private translate: TranslateService,
  ) {
    this.snoozeOptions = [5, 15, 30].map((minutes) => ({
      label: this.translate.instant('general.session_expiry.snooze_option', { minutes }),
      value: minutes,
    }));
  }

  // Primary CTA: resolve the modal so the service triggers a full logout/re-login.
  logout(): void {
    this.activeModal.close('logout');
  }

  // Secondary CTA: dismiss with the chosen grace period so the service suppresses
  // the popup for that long before re-checking.
  snooze(): void {
    this.activeModal.dismiss({ snoozeMinutes: this.snoozeMinutes });
  }
}
